import RadiusIcon from '@/components/Icons/RadiusIcon';
import SearchIconAlt from '@/components/Icons/SearchIconAlt';
import { InputAdornment, TextField } from '@mui/material';
import type { ChangeEvent } from 'react';
import StyledAddressAutocomplete from './styled/StyledAddressAutocomplete';
import StyledRadiusInputRoot from './styled/StyledRadiusInput';

interface GeoFencingProps {
  address: string;
  setAddress: (value: string) => void;
  radius: string | number;
  suggestions: string[];
  handleAddressInput: (value: string) => void;
  handleAddressSelect: (suggestion: string | null) => void;
  handleRadiusInput: (value: string) => void;
}

const GeoFencing = ({
  address,
  setAddress,
  radius,
  suggestions,
  handleAddressInput,
  handleAddressSelect,
  handleRadiusInput,
}: GeoFencingProps) => {
  const onRadiusChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleRadiusInput(e.target.value);
  };

  return (
    <div className='flex flex-col gap-1'>
      <div className='flex gap-3'>
        <StyledAddressAutocomplete
          freeSolo
          value={address}
          onChange={(_, newValue) => {
            const value = (newValue as string) || '';
            setAddress(value);
            if (value) {
              handleAddressSelect(value);
            }
          }}
          onInputChange={(_, newInputValue, reason) => {
            if (reason === 'input') {
              handleAddressInput(newInputValue);
            }
          }}
          options={suggestions}
          renderInput={params => (
            <TextField
              {...params}
              placeholder='Search by address'
              size='small'
              slotProps={{
                input: {
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position='start'>
                      <SearchIconAlt />
                    </InputAdornment>
                  ),
                },
              }}
            />
          )}
          slotProps={{
            paper: {
              sx: {
                '& .MuiAutocomplete-option': {
                  fontSize: '14px',
                  '&:hover': {
                    backgroundColor: '#DEF2EA',
                  },
                },
              },
            },
          }}
        />
        <StyledRadiusInputRoot>
          <RadiusIcon />
          <input value={radius} onChange={onRadiusChange} placeholder='Radius (in miles)' />
        </StyledRadiusInputRoot>
      </div>
    </div>
  );
};

export default GeoFencing;
